import React from "react";

// function Heading(){
//     return <h5 className="card-title">{props.title}</h5>;
// }
const Heading =(props)=>{
    return <h5 className="card-title">{props.title}</h5>;
}

export default Heading ;